(function () {
  'use strict';

  const ROOT_SELECTOR = '.shopify-section--main-product';
  const CARD_SELECTOR = '.ab-volume-discount-item-content';
  const TITLE_SELECTOR = '.ab-volume-discount-item-title-label';
  const PRICE_INFO_SELECTOR = '.ab-volume-discount-item-price-info';
  const DISCOUNT_PRICE_SELECTOR = '.ab-volume-discount-item-discount-price';
  const UNIT_PRICE_CLASS = 'nv-ab-unit-price';
  const PRICE_STACK_CLASS = 'nv-ab-price-stack';

  const BASE_PRICE_SELECTORS = [
    '.nv-pdp-price-main',
    'price-list.price-list--product .money',
    '.product-info .price-list .money'
  ];

  const BASE_UNIT_PRICE_SELECTORS = [
    '.nv-pdp-unit-price',
    'unit-price',
    '.price__unit',
    '.unit-price'
  ];

  const DAYS_REGEX = /(\d+)\s*Tage/i;
  const PRICE_REGEX = /(\d{1,3}(?:\.\d{3})*,\d{2})\s*€/i;
  const UNIT_PRICE_REGEX = /(\d{1,3}(?:\.\d{3})*,\d{2})\s*€\s*\/\s*([a-zA-Z]+)/i;

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function parseGermanNumber(value) {
    return Number(String(value).replace(/\./g, '').replace(',', '.'));
  }

  function parseEuro(text) {
    if (!text) return null;
    const match = String(text).match(PRICE_REGEX);
    if (!match) return null;
    return parseGermanNumber(match[1]);
  }

  function parseUnitPrice(text) {
    if (!text) return null;
    const match = String(text).match(UNIT_PRICE_REGEX);
    if (!match) return null;

    return {
      value: parseGermanNumber(match[1]),
      unit: match[2].toLowerCase()
    };
  }

  function formatEuro(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

  function formatUnitPrice(value, unit) {
    return `(${formatEuro(value)}/${unit})`;
  }

  function getFirstMatchingValue(root, selectors, parser) {
    for (const selector of selectors) {
      const el = root.querySelector(selector);
      if (!el) continue;
      const value = parser(el.textContent);
      if (value) return value;
    }
    return null;
  }

  function getBasePrice(root) {
    return getFirstMatchingValue(root, BASE_PRICE_SELECTORS, parseEuro);
  }

  function getBaseUnitPrice(root) {
    return getFirstMatchingValue(root, BASE_UNIT_PRICE_SELECTORS, parseUnitPrice);
  }

  function getCards(root) {
    return Array.from(root.querySelectorAll(CARD_SELECTOR)).filter((card) => {
      return card.querySelector(TITLE_SELECTOR) && card.querySelector(DISCOUNT_PRICE_SELECTOR);
    });
  }

  function getCardDays(card) {
    const titleEl = card.querySelector(TITLE_SELECTOR);
    if (!titleEl) return null;

    const match = normalizeText(titleEl.textContent).match(DAYS_REGEX);
    return match ? Number(match[1]) : null;
  }

  function getBaseDays(cards) {
    const days = cards
      .map(getCardDays)
      .filter(Boolean)
      .sort((a, b) => a - b);

    return days.length ? days[0] : null;
  }

  function getCardPrice(card) {
    const priceEl = card.querySelector(DISCOUNT_PRICE_SELECTOR);
    if (!priceEl) return null;
    return parseEuro(priceEl.textContent);
  }

  function removeExistingUnitPrices(root) {
    root.querySelectorAll(`.${UNIT_PRICE_CLASS}`).forEach((el) => el.remove());
    root.querySelectorAll(`.${PRICE_STACK_CLASS}`).forEach((el) => {
      el.classList.remove(PRICE_STACK_CLASS);
    });
  }

  function injectUnitPrice(card, text) {
    const priceInfoEl = card.querySelector(PRICE_INFO_SELECTOR);
    const discountPriceEl = card.querySelector(DISCOUNT_PRICE_SELECTOR);

    if (!priceInfoEl || !discountPriceEl) return;

    priceInfoEl.classList.add(PRICE_STACK_CLASS);

    const unitNode = document.createElement('div');
    unitNode.className = UNIT_PRICE_CLASS;
    unitNode.textContent = text;

    discountPriceEl.insertAdjacentElement('afterend', unitNode);
  }

  function updateBundleUnitPrices() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    removeExistingUnitPrices(root);

    const basePrice = getBasePrice(root);
    const baseUnitData = getBaseUnitPrice(root);

    if (!basePrice || !baseUnitData) return;

    const referenceAmount = basePrice / baseUnitData.value;
    if (!referenceAmount || !isFinite(referenceAmount)) return;

    const cards = getCards(root);
    if (!cards.length) return;

    const baseDays = getBaseDays(cards);
    if (!baseDays) return;

    cards.forEach((card) => {
      const days = getCardDays(card);
      const cardPrice = getCardPrice(card);

      if (!days || !cardPrice) return;

      const multiplier = days / baseDays;
      if (!multiplier || !isFinite(multiplier)) return;

      const bundleReferenceAmount = referenceAmount * multiplier;
      const bundleUnitPrice = cardPrice / bundleReferenceAmount;

      injectUnitPrice(card, formatUnitPrice(bundleUnitPrice, baseUnitData.unit));
    });
  }

  function init() {
    updateBundleUnitPrices();

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const observer = new MutationObserver(() => {
      window.clearTimeout(window.__nvBundleUnitPriceTimer);
      window.__nvBundleUnitPriceTimer = window.setTimeout(() => {
        updateBundleUnitPrices();
      }, 120);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();